import { API_BASE } from '../../constants/urls';

/**
 * Higher-level wrapper for fetch() with JSON deserialization, error handling, etc.
 * @param {String} method - The HTTP method to use, either POST, GET, PATCH, or DELETE.
 * @param {String} endpoint - The URL/path of the API endpoint to use.
 * @param {[Object]} data - (Optional.) Used with POST/PATCH requests.
 * @returns {Promise} The fetch-based promise that will resolve with the results.
 */
export default function fetchData(method = 'GET', endpoint = '', data, isMultiPart = false, suppliedHeaders) {
  const baseUrl = API_BASE[process.env.REACT_APP_ENVIRONMENT];
  let body = (method === 'POST' || method === 'PATCH') ? JSON.stringify(data) : undefined; // Only POST/PATCH can have a body.

  let headers = suppliedHeaders;
  if (!headers) {
    headers = {
      Accept: 'application/json, text/javascript, */*',
      'Content-Type': 'application/json',
    };
  }

  if (isMultiPart) {
    body = data;
    delete headers['Content-Type'];
  }

  const options = {
    method,
    body,
    credentials: 'include',
    headers: new Headers(headers),
  };

  if (method === 'GET') {
    delete options.body;
  }

  return fetch(`${baseUrl}${endpoint}`, options)
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    }).catch(error => ({ error }));
}



// WEBPACK FOOTER //
// ./src/utilities/fetchData/fetchData.js